declare const Ts: any;
type TypekitType = {
  load(options: any): void;
};
declare const Typekit: TypekitType;

export default function useWebFont(vue: Vue) {
  const load = () => {
    // console.log('ts', typeof TS, typeof Typekit);
    if (typeof Ts !== 'undefined') {
      // console.log('%ci%c Ts.loadFont', 'color: white; background: blue;', '');
      Ts.loadFont();
    }
    if (typeof Typekit !== 'undefined') {
      // console.log('%ci%c Typekit.load', 'color: white; background: blue;', '');
      Typekit.load({
        scriptTimeout: 1000,
        async: true,
      });
    }
  };

  // vue.$nextTick().then(() => {
  // DOMの更新サイクル後
  load();
  // });

  return {
    load,
  };
}
